import { RestService, Rest } from '@abp/ng.core';
import type { PagedResultDto } from '@abp/ng.core';
import { Injectable, inject } from '@angular/core';
import type { DownloadTokenResultDto, GetByIdsInputDto } from '../dtos/shared/models';
import type { GetTeamsInputDto, TeamCreateDto, TeamDto, TeamExcelDownloadDto, TeamUpdateDto } from '../dtos/team/models';

@Injectable({
  providedIn: 'root',
})
export class TeamService {
  private restService = inject(RestService);
  apiName = 'Planning';
  

  create = (input: TeamCreateDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, TeamDto>({
      method: 'POST',
      url: '/api/planning/teams',
      body: input,
    },
    { apiName: this.apiName,...config });
  

  delete = (id: number, config?: Partial<Rest.Config>) =>
    this.restService.request<any, void>({
      method: 'DELETE',
      url: `/api/planning/teams/${id}`,
    },
    { apiName: this.apiName,...config });
  

  deleteByIds = (ids: number[], config?: Partial<Rest.Config>) =>
    this.restService.request<any, void>({
      method: 'DELETE',
      url: '/api/planning/teams',
      params: { ids },
    },
    { apiName: this.apiName,...config });
  

  get = (id: number, config?: Partial<Rest.Config>) =>
    this.restService.request<any, TeamDto>({
      method: 'GET',
      url: `/api/planning/teams/${id}`,
    },
    { apiName: this.apiName,...config });
  

  getDownloadToken = (config?: Partial<Rest.Config>) =>
    this.restService.request<any, DownloadTokenResultDto>({
      method: 'GET',
      url: '/api/planning/teams/download-token',
    },
    { apiName: this.apiName,...config });
  

  getList = (input: GetTeamsInputDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, PagedResultDto<TeamDto>>({
      method: 'GET',
      url: '/api/planning/teams',
      params: { name: input.name, inventoryTypeId: input.inventoryTypeId, inventoryTypeName: input.inventoryTypeName, isCursorPaging: input.isCursorPaging, includeTotalCount: input.includeTotalCount, id: input.id, idFrom: input.idFrom, idTo: input.idTo, creationTime: input.creationTime, creationTimeFrom: input.creationTimeFrom, creationTimeTo: input.creationTimeTo, creatorId: input.creatorId, lastModificationTime: input.lastModificationTime, lastModificationTimeFrom: input.lastModificationTimeFrom, lastModificationTimeTo: input.lastModificationTimeTo, lastModifierId: input.lastModifierId, deletionTime: input.deletionTime, deletionTimeFrom: input.deletionTimeFrom, deletionTimeTo: input.deletionTimeTo, deleterId: input.deleterId, sorting: input.sorting, skipCount: input.skipCount, maxResultCount: input.maxResultCount },
    },
    { apiName: this.apiName,...config });
  

  getListAsExcelFile = (input: TeamExcelDownloadDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, Blob>({
      method: 'GET',
      responseType: 'blob',
      url: '/api/planning/teams/as-excel-file',
      params: { downloadToken: input.downloadToken, fields: input.fields, name: input.name, inventoryTypeId: input.inventoryTypeId, inventoryTypeName: input.inventoryTypeName, isCursorPaging: input.isCursorPaging, includeTotalCount: input.includeTotalCount, id: input.id, idFrom: input.idFrom, idTo: input.idTo, creationTime: input.creationTime, creationTimeFrom: input.creationTimeFrom, creationTimeTo: input.creationTimeTo, creatorId: input.creatorId, lastModificationTime: input.lastModificationTime, lastModificationTimeFrom: input.lastModificationTimeFrom, lastModificationTimeTo: input.lastModificationTimeTo, lastModifierId: input.lastModifierId, deletionTime: input.deletionTime, deletionTimeFrom: input.deletionTimeFrom, deletionTimeTo: input.deletionTimeTo, deleterId: input.deleterId, sorting: input.sorting, skipCount: input.skipCount, maxResultCount: input.maxResultCount },
    },
    { apiName: this.apiName,...config });
  

  getListByIds = (input: GetByIdsInputDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, TeamDto[]>({
      method: 'GET',
      url: '/api/planning/teams/by-ids',
      params: { ids: input.ids },
    },
    { apiName: this.apiName,...config });
  

  update = (id: number, input: TeamUpdateDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, TeamDto>({
      method: 'PUT',
      url: `/api/planning/teams/${id}`,
      body: input,
    },
    { apiName: this.apiName,...config });
}